import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import LabelValueItem from '../../lead/components/LabelValueItem';

interface ManagedLeadDetailDatumProps {
  label: string;
  value: string;
}

/** A single read-only label/value pair of a managed lead detail section. */
export const ManagedLeadDetailDatum = ({
  label,
  value,
}: ManagedLeadDetailDatumProps) => (
  <LabelValueItem containerSx={{ pt: 2 }} label={label} value={value} />
);

interface ManagedLeadDetailSectionProps {
  title: string;
  /** Sits opposite the title, where Mutui puts the edit affordance of a box. */
  action?: ReactNode;
  children: ReactNode;
}

/** A managed lead detail box aligned with the Mutui detail page. */
export const ManagedLeadDetailSection = ({
  title,
  action = null,
  children,
}: ManagedLeadDetailSectionProps) => (
  <Box
    component="section"
    sx={{
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      bgcolor: 'white',
      my: 2,
      p: 2,
      minWidth: '300px',
    }}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
          width: '100%',
          pb: 1,
          alignItems: 'center',
        }}
      >
        <Typography
          component="h2"
          fontWeight="bold"
          textTransform="uppercase"
          sx={{
            color: (theme) => theme.palette.secondary.dark,
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
        {action}
      </Box>

      <Box pt={1}>{children}</Box>
    </Box>
  </Box>
);
